import styled from 'styled-components';

const ServiceBoxContainer = styled.div`
    display: flex;
    @media (max-width: 767px) {
        display: flex;
        flex-direction: column;
        text-align: center;
        margin-bottom: 40px;
    }
    i {
        margin-right: 50px;
        @media (max-width: 767px) {
            margin: 0 0 30px;
        }
    }
    h3 {
        margin-bottom: 30px;
        color: var(--main-color);
    }
    p {
        line-height: 2;
        color: #777;
    }
`;

export default ServiceBoxContainer;
